import { GetCurrentPolicyAssignmentsDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export const useCurrentEmployeesInPolicy = (ids: number[]) => {
  const { loading, data, error } = useQuery(GetCurrentPolicyAssignmentsDocument, {
    variables: { ids },
  })

  return {
    loading,
    currentPolicyAssignments: data?.timeoff.currentPolicyAssignments || [], // Provide a default value,
    error,
  }
}
